import { render, staticRenderFns } from "./Takephoto.vue?vue&type=template&id=33ff8e32"
import script from "./Takephoto.vue?vue&type=script&lang=js"
export * from "./Takephoto.vue?vue&type=script&lang=js"
import style0 from "./Takephoto.vue?vue&type=style&index=0&id=33ff8e32&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports